// extracted by mini-css-extract-plugin
export default {"content":"Main_content__JlVXI"};